export default "__VITE_ASSET__D4lptOc9__"